export function About() {
  return (
    <div className="flex flex-col text-center gap-2 md:w-1/2 w-3/4">
      <h1 className="text-4xl font-semibold">About our team</h1>
      <p className="flex flex-col italic font-light gap-2 text-md">
        <p>Hi there!</p>
        <p>
          We are team OnlyCalves, participating for the third time in Ragnar
          Northwest Passage! There is a friendly competition between the members
          of our past and present roster about who has the best calves...so
          naturally, we had to crowdsource this information. Please contribute
          to our vanity
        </p>

        <p>....we really need it</p>
      </p>
    </div>
  );
}
